const INPUTS = [
  { t: 'Public government data', s: 'FPDS · USASpending · SAM.gov' },
  { t: 'Vendor-provided via Gateway', s: 'Profiles · specs · certifications' },
  { t: 'Regulation and policy', s: 'FAR · DFARS · supplements, versioned' },
  { t: "Your office's records", s: 'Archives · templates · lessons learned' },
]

const CORE = [
  { t: 'Market Ledger', s: "Who builds what, who owns whom, what they've delivered" },
  { t: 'Pathways and authorities', s: 'Every route to capability, thresholds and trade-offs explicit' },
  { t: 'Office knowledge', s: 'What your offices have evaluated, fielded, and learned' },
]

const OUTPUTS = [
  { t: 'Comparable, assessed solutions', s: 'Fit · capacity · eligibility · ownership' },
  { t: 'The fastest responsible pathway', s: 'Ranked · trade-offs and authorities stated' },
  { t: 'A program sized to the need', s: 'Prototype buy, Program of Record, or the transition between' },
  { t: 'A record leadership can see', s: 'Auditable · portfolio-visible · reusable' },
]

export default function Engine() {
  return (
    <section id="engine" className="lp-sec lp-sec--dark">
      <div className="lp-wrap">
        <div className="lp-engine__head">
          <div style={{ minWidth: 0 }}>
            <div className="lp-eyebrow">THE ACQUISITION ENGINE</div>
            <h2 className="lp-h2">Finally: the tools you need to deliver at speed.</h2>
          </div>
          <p>
            Your markets, your rules, all in one place. Match a gap to the right
            solution, pick the best pathway, and move out the same day.
          </p>
        </div>

        <div className="lp-flow">
          <div className="lp-flow__col">
            <div className="lp-flow__label">PULLED IN AUTOMATICALLY</div>
            {INPUTS.map((i) => (
              <div key={i.t} className="lp-flow__item">
                {i.t}
                <span>{i.s}</span>
              </div>
            ))}
          </div>

          <div className="lp-flow__core">
            <div className="lp-flow__core-head">
              <img src="/overmatch-logo-white.png" alt="" />
              <span>ENGINE</span>
            </div>
            {CORE.map((c) => (
              <div key={c.t} className="lp-flow__core-item">
                <h3>{c.t}</h3>
                <p>{c.s}</p>
              </div>
            ))}
          </div>

          <div className="lp-flow__col">
            <div className="lp-flow__label">WHAT YOUR PROGRAM GETS</div>
            {OUTPUTS.map((o) => (
              <div key={o.t} className="lp-flow__item lp-flow__item--out">
                {o.t}
                <span>{o.s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
